import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { F } from "../fonts";
import { useDesigns } from "../api";

const C = {
  vanilla: "#F8F4EE",
  umber:   "#443A35",
};

const PhotographyPage = () => {
  const navigate = useNavigate();
  const { designs } = useDesigns();
  const photographyDesign = designs.find((d) => d.category === "Photography");
  const photos = photographyDesign?.gallery || [];

  return (
    <Box sx={{ backgroundColor: C.umber, minHeight: "100vh", color: C.vanilla }}>
      {/* ── Top bar ── */}
      <Box sx={{
        px: "40px", py: "22px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        borderBottom: "1px solid rgba(248,244,238,0.08)",
        position: "sticky", top: 0, zIndex: 100,
        backgroundColor: "rgba(68,58,53,0.92)",
        backdropFilter: "blur(12px)",
      }}>
        <Box
          onClick={() => navigate("/")}
          sx={{
            display: "flex", alignItems: "center", gap: 1.5,
            cursor: "pointer", color: "rgba(248,244,238,0.5)",
            transition: "color 0.2s ease",
            "&:hover": { color: C.vanilla },
          }}
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"/>
            <polyline points="12 19 5 12 12 5"/>
          </svg>
          <Typography sx={{ fontSize: "12px", letterSpacing: "2.5px", fontFamily: F.heading }}>BACK</Typography>
        </Box>
      </Box>

      {/* ── Page title ── */}
      <Box sx={{ px: "40px", pt: "70px", pb: "60px" }}>
        <Typography sx={{
          fontSize: "clamp(60px, 9vw, 110px)",
          fontFamily: F.heading,
          fontWeight: 700,
          letterSpacing: "5px",
          lineHeight: 0.95,
          color: C.vanilla,
        }}>
          CAPTURED
        </Typography>
        <Typography sx={{
          fontSize: "clamp(60px, 9vw, 110px)",
          fontFamily: F.heading,
          fontWeight: 700,
          letterSpacing: "5px",
          lineHeight: 0.95,
          color: "rgba(248,244,238,0.12)",
        }}>
          MOMENTS
        </Typography>
        <Typography sx={{
          mt: 4,
          fontSize: "14px",
          fontFamily: F.body,
          color: "rgba(248,244,238,0.38)",
          letterSpacing: "0.5px",
          maxWidth: "480px",
          lineHeight: 1.7,
        }}>
          Beyond design, I capture moments through photography — visual
          storytelling that shapes how I create meaningful experiences.
        </Typography>
      </Box>

      {/* ── Masonry ── */}
      <Box sx={{ px: "40px", pb: "100px" }}>
        <Box sx={{
          columnCount: { xs: 2, md: 4 },
          columnGap: "12px",
        }}>
          {photos.map((src, i) => (
            <Box key={i} sx={{
              breakInside: "avoid",
              mb: "12px",
              borderRadius: "8px",
              overflow: "hidden",
              backgroundColor: "rgba(248,244,238,0.08)",
              "& img": { transition: "transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94)" },
              "&:hover img": { transform: "scale(1.07)" },
            }}>
              <Box component="img" src={src} alt=""
                sx={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "cover",
                }} />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default PhotographyPage;
